import dayjs from 'dayjs';
import { IUser } from 'app/shared/model/user.model';
import { Title } from 'app/shared/model/enumerations/title.model';
import { Nationality } from 'app/shared/model/enumerations/nationality.model';
import { District } from 'app/shared/model/enumerations/district.model';
import { City } from 'app/shared/model/enumerations/city.model';
import { Province } from 'app/shared/model/enumerations/province.model';
import { ResidencePurpose } from 'app/shared/model/enumerations/residence-purpose.model';

export interface IForeignerResidence {
  id?: number;
  recordNumber?: string;
  createDate?: dayjs.Dayjs | null;
  recordDate?: dayjs.Dayjs | null;
  recordLocation?: string | null;
  foreignerTitle?: keyof typeof Title | null;
  foreignerFullName?: string;
  nationality?: keyof typeof Nationality;
  foreignerPassportNo?: string;
  houseNo?: string | null;
  moo?: number | null;
  district?: keyof typeof District;
  city?: keyof typeof City;
  province?: keyof typeof Province;
  condition37?: boolean | null;
  condition38?: boolean | null;
  purpose?: keyof typeof ResidencePurpose | null;
  purposeOther?: string | null;
  officer?: IUser | null;
}

export const defaultValue: Readonly<IForeignerResidence> = {
  condition37: false,
  condition38: false,
};
